var React = require('react');

function ClientsInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","fill":"currentColor","stroke":"currentColor"},[React.createElement("path",{"data-color":"color-2","fill":"none","strokeMiterlimit":"10","d":"M1,23 c0-5.523,4.477-10,10-10h2c5.523,0,10,4.477,10,10","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10","cx":"12","cy":"7","r":"6","key":1})]));
}

ClientsInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ClientsInline;

ClientsInline.default = ClientsInline;
